let id = 0;

export default class Toast {
  constructor(data) {
    Object.assign(this, data);
    id += 1;
    this.id = id;
  }
}
